/**
 * Mixin: externalAssets
 *
 * Loads per-section CSS and JS overrides from external URLs at mount time
 * and cleans them up on unmount. Works with any section component that
 * receives its data via a `sectionData` or `heroData` prop.
 *
 * Supported fields on the section data object:
 *   css_url  — external stylesheet to inject (hotfix styles, campaign overrides)
 *   js_url   — external script to inject (hotfix logic, extra interactivity)
 *
 * Both files live on GCS and can be updated without a build or deploy.
 */

function getAssets(vm) {
  const data = vm.sectionData || vm.heroData || {};
  const id = vm.sectionId || data.id || 'section';
  return { id, css_url: data.css_url, js_url: data.js_url };
}

export default {
  mounted() {
    const { id, css_url, js_url } = getAssets(this);

    if (css_url && !document.getElementById(`section-css-${id}`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css_url;
      link.id = `section-css-${id}`;
      document.head.appendChild(link);
    }

    if (js_url && !document.getElementById(`section-js-${id}`)) {
      const script = document.createElement('script');
      script.src = js_url;
      script.id = `section-js-${id}`;
      document.head.appendChild(script);
    }
  },

  beforeUnmount() {
    const { id } = getAssets(this);
    document.getElementById(`section-css-${id}`)?.remove();
    document.getElementById(`section-js-${id}`)?.remove();
  },
};
